export default {
      id: "facebook-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "svg/sprite.svg#facebook",
      toString: function () {
        return this.url;
      }
    }